import { render } from "./HomeDashboardSidebar.vue?vue&type=template&id=258cc2a5"
import script from "./HomeDashboardSidebar.vue?vue&type=script&lang=js"
export * from "./HomeDashboardSidebar.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__